import styled from '@emotion/styled';
import { Tr } from '@lightspeed/cirrus-table';
import { Card } from '@lightspeed/flame/Card';
import { Box } from '@lightspeed/flame/Core';
import { Modal } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

interface StyledBannerProps {
  showBackground: boolean;
}

export const StyledBanner = styled(Card)<StyledBannerProps>`
  background: ${(props) =>
    props.showBackground
      ? `no-repeat right url('https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/payments/grey-curve.png') white`
      : 'white'};
  background-size: 350px 100%;
  margin-bottom: 30px;
`;

export const StyledWarningIcon = styled(Box)`
  position: absolute;
  top: 100px;
  right: 10px;
`;

export const StyledTr = styled(Tr)`
  &:not(:last-child) {
    border-bottom: 1px solid #d7dce1;
  }
`;

export const StyledModal = styled(Modal)`
  width: 600px;
`;

export const EllipsisText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 160px;
  white-space: nowrap;
`;

// We must define our InputGroup as the ToolTip component negates the
// overwritten styles of the Button component
export const CustomInputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0;

  & button,
  a {
    width: 40px;
    border-radius: 0;
  }

  & > span:first-of-type > * {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  & > span:last-of-type > * {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  & > span:not(:first-of-type) > * {
    border-left: 0;
  }
`;
